<template>
  <div class="container">
    <div id="mainView" class="flow__body" data-test-policy-view-mode="1">
      <div v-cloak :data-test-policy-id="modelValue.PolicyNumber" class="row">
        <div class="small-12 medium-12 large-6 columns">
          <div class="policy-detail-view">
            <h1>{{ modelValue.PolicyName }}</h1>

            <renewal v-if="inRenewal" v-model="modelValue.Renewal" />

            <activate-edit-mode-button
              :width="8"
              :show="!basketFixed"
              :disabled="!isEditingEnabled"
            />

            <info-box
              v-if="isEditable && !isEditingEnabled"
              arrow-align="left"
              :text="modelValue.EditContent.EditingDisabledMessage"
            />

            <policy-information v-model="modelValue.PolicyInformation" />
            <insured-item v-model="modelValue.InsuredItem" />
            <deductible v-if="modelValue.ShowDeductible" v-model="modelValue.Deductible" />
            <coverages v-model="modelValue.Coverages" />
            <payment v-model="modelValue.PaymentInformation" />
            <clauses v-model="modelValue.Clauses" />

            <page-spinner :spinner-url-list="spinnerUrlList" class="hide-for-large" />
          </div>
        </div>

        <basket :model-value="modelValue" />
      </div>

      <!-- TODO: SERY - Tempoary Modal due to Clause error. Will be removed after fix. ref: PFK-2784 -->
      <transition v-cloak name="modal">
        <v-modal
          :is-open="showClauseErrorModal"
          modal-class="alt-modal"
          @close="setShowClauseErrorModal(false)"
        >
          <template #content>
            <div class="row align-center text-center">
              <p class="clause-error-modal-text" v-html="value?.ClauseErrorModalText" />
            </div>
          </template>

          <template #buttons>
            <div class="row align-center">
              <button
                class="button small-11 text-center"
                @click="setShowClauseErrorModal(false)"
                v-html="value?.ClauseErrorModalButtonText"
              />
            </div>
          </template>
        </v-modal>
      </transition>
    </div>

    <mobile-terms-button />
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import ActivateEditModeButton from './ActivateEditModeButton.vue';
import Basket from './Basket.vue';
import Clauses from './Clauses.vue';
import Coverages from './Coverages.vue';
import Deductible from './Deductible.vue';
import InfoBox from '@/components/UI/InfoBox.vue';
import InsuredItem from './InsuredItem.vue';
import MobileTermsButton from './MobileTermsButton.vue';
import PageSpinner from '@/components/UI/PageSpinner.vue';
import Payment from './Payment.vue';
import PolicyInformation from './PolicyInformation.vue';
import Renewal from './Renewal.vue';
import data from './_content.json';
import { hashScroll } from '@/common/hashScroll';
import './Header.vue'; // TODO: is this needed?

export default {
  name: 'PolicyMode',
  components: {
    ActivateEditModeButton,
    PageSpinner,
    Basket,
    PolicyInformation,
    InfoBox,
    InsuredItem,
    MobileTermsButton,
    Deductible,
    Coverages,
    Payment,
    Clauses,
    Renewal
  },
  props: {
    modelValue: {
    type: Object,
      default() {
        return null;
      }
    },
  },
  data() {
    return {
      data,
      isScrolled: false,
      showClauseErrorModal: false
    };
  },
  computed: {
    basketFixed() {
      return this.$store.state.policy.basketFixed;
    },
    editMode() {
      return this.$store.state.policy.editMode;
    },
    policyId() {
      return Utility.getQueryVariable('id');
    },
    spinnerUrlList() {
      return [
        Utility.constants().API.policy_edit_initiate + this.policyId,
        Utility.constants().API.policy_get + this.policyId,
        Utility.constants().API.policy_edit_update_amount_reference,
        Utility.constants().API.policy_edit_add,
        Utility.constants().API.policy_edit_remove,
        Utility.constants().API.policy_edit_cover,
        Utility.constants().API.policy_edit_amount,
        Utility.constants().API.policy_edit_save
      ];
    },
    inRenewal() {
      if (this.modelValue.Renewal === null) {
        return false;
      }

      return this.$store.getters['policy/inRenewal'];
    },
    isEditingEnabled() {
      return this.$store.getters['policy/isEditingEnabled'];
    },
    isEditable() {
      return this.$store.getters['policy/isEditable'];
    }
  },
  watch: {
    editMode(val) {
      if (val) {
        this.$store.dispatch('policy/registerEvent', 'policy-view-edit-mode-activated');
      }
    }
  },
  mounted() {
    const vm = this;

    $(document).ready(() => {
      vm.setBasketPosition();
    });

    window.addEventListener('scroll', () => {
      vm.setBasketPosition();
      vm.hideTermsButtonMobile();
    });

    hashScroll();

    if (this.ShouldShowClauseErrorModal) {
      this.showClauseErrorModal = true;
    }
  },
  methods: {
    siteBasketPosition() {
      const elm = document.getElementById('site-basket');

      if (elm !== null) {
        return elm.style.position;
      }

      return null;
    },
    siteBasketFixed() {
      return this.siteBasketPosition() === 'fixed';
    },
    setBasketPosition() {
      if (this.siteBasketFixed()) {
        return this.$store.dispatch('policy/setBasketPosition', true);
      }

      return this.$store.dispatch('policy/setBasketPosition', false);
    },
    hideTermsButtonMobile() {
      const elm = document.getElementById('terms-button');

      if (elm === null) {
        return;
      }

      if (window.scrollY > 0) {
        return (elm.style.opacity = 0);
      }

      return (elm.style.opacity = 1);
    },
    setShowClauseErrorModal(val) {
      this.showClauseErrorModal = val;
    }
  }
  // inject: ['$validator']
};
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.margin {
  margin-top: rem-calc(20px);
}

.clause-error-modal-text {
  margin-top: rem-calc(20);
  margin-right: rem-calc(20);
  margin-left: rem-calc(20);
}
</style>
